export default {
    MCB: 'MCB',
    LOAIDT: 'LOAIDT',
    CHUCVU: 'CHUCVU',
    NGACHLUONG: 'NGACHLUONG',
    PHONGBAN: 'PHONGBAN',
    CHUCVU: 'CHUCVU',
    HOTEN: 'HOTEN',
    SOLUONG: 'SOLUONG'
}